import { createContext, useContext } from "react";

export const DraftModeContext = createContext<boolean>(false);

export const DraftModeProvider = ({
	children,
	isEnabled,
}: { children: React.ReactNode; isEnabled: boolean }) => {
	return <DraftModeContext.Provider value={isEnabled}>{children}</DraftModeContext.Provider>;
};

export const useDraftMode = () => {
	return useContext(DraftModeContext);
};
